import InputField from "./InputField";
import RadioField from "./RadioField";
import TextareaField from "./TextareaField";
import CheckboxField from "./CheckboxField";
import SelectField from "./SelectField";

export { InputField, RadioField, TextareaField, CheckboxField, SelectField };

export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_FORMAT_RHIHD201907 = "DD/MM/YY";

export const getPropsFromData = (data, fieldName) => ({
  name: fieldName,
  ...(data[fieldName] || {}),
});



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/FormField/index.js